import React from 'react';
import styles from './SlowerButton.module.css';

interface SlowerButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  /** The key that plays the clip slower (named for assistive tech and in the tooltip). */
  shortcut?: string;
}

export const SlowerButton: React.FC<SlowerButtonProps> = ({
  onClick,
  disabled = false,
  className,
  shortcut,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${styles.slowerButton} ${className || ''}`}
      aria-label="Play slower audio"
      aria-keyshortcuts={shortcut}
      title={shortcut ? `Play slower audio (${shortcut})` : undefined}
    >
      Slower
    </button>
  );
};

export default SlowerButton;
